import { useTranslation } from 'react-i18next'
import { ContentSection } from '../components/content-section'
import { LanguageForm } from './language-form'

export function SettingsLanguage() {
  const { t } = useTranslation('common')

  return (
    <ContentSection
      title={t('settings.languageOptions')}
      desc={t('settings.languageDescription')}
    >
      <LanguageForm />
    </ContentSection>
  )
}
